export default __webpack_public_path__ + "static/media/landing-desktop.fb630b04.jpg";